/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Combine_2Inputs */

const en_pc_tut_combine_2 = /** @type {(inputs: Pc_Tut_Combine_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extract: select pages in Organize pages and choose Extract to copy them into a new document.`)
};

const zh_pc_tut_combine_2 = /** @type {(inputs: Pc_Tut_Combine_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提取：在「Organize pages」中选中页面，选择「Extract」把它们复制成新文档。`)
};

/**
* | output |
* | --- |
* | "Extract: select pages in Organize pages and choose Extract to copy them into a new document." |
*
* @param {Pc_Tut_Combine_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_combine_2 = /** @type {((inputs?: Pc_Tut_Combine_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Combine_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_combine_2(inputs)
	return zh_pc_tut_combine_2(inputs)
});
export { pc_tut_combine_2 as "pc.tut.combine.2" }